<script lang="ts">
	import { createEventDispatcher, getContext } from "svelte";
	import { scale, fade } from "svelte/transition";
	import { mode } from "../stores";
	import { modeData, timeRemaining } from "../utils";
	import GameIcon from "./GameIcon.svelte";
	import type { Toaster } from "./widgets";

	export let showStats: boolean;
	export let tutorial: boolean;
	export let showRefresh: boolean;

	export let toaster = getContext<Toaster>("toaster");

	const dispatch = createEventDispatcher();
	mode.subscribe((m) => {
		if (timeRemaining(modeData.modes[m]) > 0) {
			showRefresh = false;
		}
	});
</script>

<header>
	<div class="icons">
		<GameIcon onClick={() => dispatch("tutorial")}>
			<path
				d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
			/>
		</GameIcon>
		{#if showRefresh}
			<GameIcon onClick={() => dispatch("reload")}>
				<path
					transition:fade={{ duration: 200 }}
					d="M4.609 12c0-4.082 3.309-7.391 7.391-7.391a7.39 7.39 0 0 1 6.523 3.912l-1.653 1.567H22v-5.13l-1.572 1.659C18.652 3.841 15.542 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10c4.589 0 8.453-3.09 9.631-7.301l-2.512-.703c-.871 3.113-3.73 5.395-7.119 5.395-4.082 0-7.391-3.309-7.391-7.391z"
				/>
			</GameIcon>
		{/if}
	</div>
	<h1
		on:click|self={() => {
			$mode = ($mode + 1) % modeData.modes.length;
			toaster.pop(modeData.modes[$mode].name);
		}}
		on:contextmenu|preventDefault|self={() => {
			$mode = ($mode - 1 + modeData.modes.length) % modeData.modes.length;
			toaster.pop(modeData.modes[$mode].name);
		}}
	>
	Foodle Unlimited
	</h1>
	<div class="icons">
		{#if showStats}
			<GameIcon onClick={() => dispatch("stats")}>
				<svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g id="Icon"><path d="M2,22.75l20,0c0.414,-0 0.75,-0.336 0.75,-0.75c-0,-0.414 -0.336,-0.75 -0.75,-0.75l-20,0c-0.414,-0 -0.75,0.336 -0.75,0.75c-0,0.414 0.336,0.75 0.75,0.75Z"></path><path d="M7.75,16.5c0,-0.332 -0.132,-0.649 -0.366,-0.884c-0.235,-0.234 -0.553,-0.366 -0.884,-0.366c-0.769,0 -2.231,0 -3,0c-0.331,-0 -0.649,0.132 -0.884,0.366c-0.234,0.235 -0.366,0.552 -0.366,0.884c0,1.441 0,5.5 0,5.5c0,0.414 0.336,0.75 0.75,0.75l4,0c0.414,0 0.75,-0.336 0.75,-0.75l-0,-5.5Zm-4,0.25l2.5,-0l0,4.5c0,-0 -2.5,0 -2.5,0l0,-4.5Z"></path><path d="M14.75,22l-0,-8.5c-0,-0.332 -0.132,-0.649 -0.366,-0.884c-0.235,-0.234 -0.553,-0.366 -0.884,-0.366c-0.769,0 -2.231,0 -3,0c-0.331,-0 -0.649,0.132 -0.884,0.366c-0.234,0.235 -0.366,0.552 -0.366,0.884l0,8.5c0,0.414 0.336,0.75 0.75,0.75l4,0c0.414,0 0.75,-0.336 0.75,-0.75Zm-4,-8.25l2.5,-0l0,7.5c0,-0 -2.5,0 -2.5,0l0,-7.5Z"></path><path d="M21.75,9.5c0,-0.332 -0.132,-0.649 -0.366,-0.884c-0.235,-0.234 -0.553,-0.366 -0.884,-0.366c-0.769,0 -2.231,0 -3,0c-0.331,-0 -0.649,0.132 -0.884,0.366c-0.234,0.235 -0.366,0.552 -0.366,0.884c0,2.386 0,12.5 0,12.5c0,0.414 0.336,0.75 0.75,0.75l4,0c0.414,0 0.75,-0.336 0.75,-0.75l-0,-12.5Zm-4,0.25l2.5,-0l0,11.5c0,-0 -2.5,0 -2.5,0l0,-11.5Z"></path><path d="M18.181,2.389c-1.172,1.934 -4.513,4.058 -8.726,5.45c-1.842,0.61 -3.635,1.002 -5.251,1.181c-0.412,0.046 -0.709,0.417 -0.663,0.828c0.046,0.412 0.417,0.709 0.828,0.663c1.71,-0.19 3.608,-0.603 5.557,-1.247c4.636,-1.533 8.248,-3.97 9.537,-6.098c0.215,-0.354 0.102,-0.815 -0.252,-1.03c-0.354,-0.214 -0.816,-0.101 -1.03,0.253Z"></path><path d="M16.682,3.044l2.066,-0.219c0,-0 0.22,2.067 0.22,2.067c0.043,0.411 0.413,0.71 0.825,0.666c0.411,-0.043 0.71,-0.413 0.666,-0.825l-0.298,-2.812c-0.044,-0.412 -0.413,-0.711 -0.825,-0.667l-2.813,0.299c-0.411,0.043 -0.71,0.413 -0.666,0.825c0.043,0.411 0.413,0.71 0.825,0.666Z"></path></g></svg>
			</GameIcon>
		{/if}
		<GameIcon onClick={() => dispatch("settings")}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><defs><style>.cls-1{fill:#35353d;}</style></defs><title>Asset 67</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M59.2,23.58a4.41,4.41,0,0,1-2-4.86A9.79,9.79,0,0,0,45.27,6.81a4.4,4.4,0,0,1-4.85-2,9.79,9.79,0,0,0-16.84,0,4.39,4.39,0,0,1-4.86,2A9.79,9.79,0,0,0,6.81,18.73a4.39,4.39,0,0,1-2,4.85,9.79,9.79,0,0,0,0,16.84,4.4,4.4,0,0,1,2,4.86A9.79,9.79,0,0,0,18.73,57.19a4.4,4.4,0,0,1,4.85,2,9.79,9.79,0,0,0,16.84,0,4.41,4.41,0,0,1,4.86-2A9.79,9.79,0,0,0,57.19,45.27a4.4,4.4,0,0,1,2-4.85,9.79,9.79,0,0,0,0-16.84ZM56.44,35.76A9.84,9.84,0,0,0,52,46.63a4.37,4.37,0,0,1-5.33,5.31,9.86,9.86,0,0,0-10.86,4.5,4.36,4.36,0,0,1-7.52,0,9.85,9.85,0,0,0-8.45-4.8,9.56,9.56,0,0,0-2.42.31,4.37,4.37,0,0,1-5.31-5.33,9.85,9.85,0,0,0-4.5-10.86,4.36,4.36,0,0,1,0-7.52,9.84,9.84,0,0,0,4.49-10.87,4.38,4.38,0,0,1,5.34-5.31,9.85,9.85,0,0,0,10.85-4.5,4.36,4.36,0,0,1,7.52,0,9.84,9.84,0,0,0,10.87,4.49A4.38,4.38,0,0,1,52,17.38a9.83,9.83,0,0,0,4.49,10.86,4.36,4.36,0,0,1,0,7.52Z"></path><path class="cls-1" d="M32,18.47A13.53,13.53,0,1,0,45.53,32,13.55,13.55,0,0,0,32,18.47Zm0,21.65A8.12,8.12,0,1,1,40.12,32,8.13,8.13,0,0,1,32,40.12Z"></path></g></g></svg>

			
		</GameIcon>
	</div>
	{#if tutorial}
		<div transition:scale class="tutorial" on:click={() => dispatch("closeTutPopUp")}>
			Click WORDLE UNLIMITED to change the game mode.
			<span class="ok">OK</span>
		</div>
	{/if}
</header>
<style lang="scss">
	header {
		--height: 60px;
		position: relative;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: var(--height);
		background: var(--bg-primary);
	}
	.icons {
		height: 100%;
		z-index: 1;
		display: flex;
		margin: 0 10px;
	}
	.light .icons svg path {
		fill: var(--bg-brand-color);
	}
	.icons svg path {
    	fill: var(--bg-brand-sec);
	}
	h1 {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		font-size: var(--fs-medium);
		cursor: pointer;
		text-align: center;
		font-family: "Sriracha", cursive;
		color: var(--bg-brand-color);
		font-size: 1.8rem;
		-webkit-text-stroke-width: 1px;
		-webkit-text-stroke-color: var(--bg-brand-color);
		@media (max-width: 700px) {
			font-size: 1rem; // Font size for smaller screens
		}
	}
</style>
